
import { PatientGender, usePatientStore } from '@/store/patient';
import { useRequestDataStore } from '@/store/request-data';
import { computed, defineComponent } from 'vue'
import { useI18n } from 'vue-i18n';

export default defineComponent({
    setup() {
        const translator = useI18n();
        const patient = usePatientStore();
        const requestData = useRequestDataStore();

        const genderIcon = computed(() => {
            if (patient.gender === PatientGender.Male) {
                return require("@/assets/pictos/genders/male.svg");
            }

            if (patient.gender === PatientGender.Female) {
                return require("@/assets/pictos/genders/female.svg");
            }

            return require("@/assets/pictos/genders/unknown.svg");
        });

        const genderAltText = computed(() => {
            if (patient.gender === null) {
                return translator.t('gender.unknown');
            }

            return translator.t(`gender.${patient.gender}`);
        });

        return { patient, requestData, genderIcon, genderAltText };
    },
})
